import { useState, useEffect } from "react";
import useFocusFormElements from "../form/useFocusFormElements";

const useFocusableExternalSerachScreenElements = () => {
  const [rootContainer, setRootContainer] = useState(null);
  useFocusFormElements(rootContainer, "");

  useEffect(() => {
    const extenalLookupIframe = window?.self?.name || "";

    if (extenalLookupIframe === "external-lookup-iframe") {
      const timeout = setTimeout(() => {
        const rootElement = document.querySelector("#root");
        const containerDiv = rootElement.querySelector("div.container");
        if (containerDiv) containerDiv.style.margin = 0;
        setRootContainer(rootElement);
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, []);
};

export default useFocusableExternalSerachScreenElements;
